import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";
import type { ListParams } from "../components";

export type Approval = { id: string; key: string; title: string; context: Record<string, unknown>; status: string; policy_name: string; requested_by_email: string; target_type: string; object_id: string; approver_ids: string[]; current_step: number; due_at: string | null; decided_at: string | null; decisions: { approver_email: string; approved: boolean; note: string; created_at: string }[]; can_decide: boolean; created_at: string };

async function unwrap<T>(p: Promise<{ data?: unknown; error?: unknown }>): Promise<T> {
  const { data, error } = await p;
  if (error) throw new Error(errorMessage(error));
  return data as T;
}

export function useInbox() {
  return useQuery({ queryKey: ["approvals", "inbox"], refetchInterval: 60_000, queryFn: () => unwrap<Approval[]>(api.GET("/api/v1/workflow/approvals/inbox/")) });
}
export function useApprovals(params: ListParams) {
  return useQuery({ queryKey: ["approvals", params], queryFn: () => unwrap<{ count: number; results: Approval[] }>(api.GET("/api/v1/workflow/approvals/", { params: { query: params as never } })) });
}
export function useDecide() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, action, note }: { id: string; action: "approve" | "reject" | "cancel"; note?: string }) => {
      const path = `/api/v1/workflow/approvals/{id}/${action}/` as "/api/v1/workflow/approvals/{id}/approve/";
      return unwrap<Approval>(api.POST(path, { params: { path: { id } }, body: { note: note ?? "" } as never }));
    },
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ["approvals"] }); void qc.invalidateQueries({ queryKey: ["dashboard"] }); },
  });
}
